import { RouterModule } from '@angular/router';
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  DsBoxModule,
  DsColumnData,
  DsFormFieldModule,
  DsIconModule,
  DsLoadingAreaConfiguration,
  DsLoadingAreaService,
  DsModalModule, DsPopoverModule,

  DsTableConfig,
  DsTableModule,

  DsToastService,
} from '@bmw-ds/components';
import { FormsModule } from '@angular/forms';
import { UnitUpdateModalComponent } from '../modals/unit-update/unit-update-modal';
import { CrossBorderService } from '../../services/crossborder.service';
import { PlannedVehicleRowData } from '../../models/planned-vehicle-row.model';
import { FreeAllocationModalComponent } from '../modals/free-allocation/free-allocation-modal.';
import { UpdateCommentModalComponent } from '../modals/update-comment/update-comment-modal';
import { ModelPricingModalComponent } from '../modals/model-pricing/model-pricing-modal';
import { PricePerBodyRequest } from '../../models/price-per-body.model';
import { PricePerBodyService } from '../../services/price-per-body.service';
import { UnitSearchReserveRequest } from '../../models/unit-search-reserve.models';
import {COMMON_IMPORTS} from "../../shared/common-imports";
@Component({
  selector: 'app-table',
  standalone: true,
  imports: [
    DsTableModule,
    CommonModule,
    FormsModule,
    DsIconModule,
    DsBoxModule,
    DsModalModule,
    DsFormFieldModule,
    RouterModule,
    DsPopoverModule,
    FreeAllocationModalComponent,
    UpdateCommentModalComponent,
    ModelPricingModalComponent,
    COMMON_IMPORTS
  ],
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
})
export class TableComponent {
  @ViewChild(UnitUpdateModalComponent) unitUpdate!: UnitUpdateModalComponent;
  @ViewChild(ModelPricingModalComponent)
  modelPricingModal!: ModelPricingModalComponent;
  @ViewChild(UpdateCommentModalComponent)
  updateCommentModalComponent!: UpdateCommentModalComponent;
  @ViewChild(FreeAllocationModalComponent)
  freeAllocation!: FreeAllocationModalComponent;
  @Input() rowsData: PlannedVehicleRowData[] = [];
  @Input() columnData: DsColumnData[] = [];
  @Input() showTable: boolean = false;

  @Input() showResults: boolean = false;

  constructor(
    private loadingAreaService: DsLoadingAreaService,
    private toastService: DsToastService,
    private crossBorderService: CrossBorderService,
  private pricePerBodyService: PricePerBodyService,
  ) {}

  pricePerBodyRequest: PricePerBodyRequest = {
    bodyno: '',
    vin: '',
  };

  @Output() downloadClick = new EventEmitter<string | number>();

  loadingAreaConfig: DsLoadingAreaConfiguration = { id: 'bodyLoading' };

  config: Partial<DsTableConfig> = {
    hasColumnDivider: true,
    hasStickyHeader: true,
    hasZebraRows: true,
  };
  modalIsOpen: boolean = false;
  model: File | null = null;
  protected readonly Number = Number;

  openUpdateModal(vin: string | number, bodyNo: string) {
    console.log(vin);
    this.unitUpdate.getUnitUpdateModalIsOpen(vin, bodyNo);
  }

  protected readonly console = console;

  doFs(vin: string, bodyNo: string, ind: string) {
    console.log(bodyNo);
    console.log(vin);
    this.freeAllocation.activateFreeAllocationModal(vin, bodyNo,ind);
  }
  onPricingClick(bodyNo: string) {
    this.loadingAreaConfig = {
      id: 'bodyLoading',
      loadingTitle: 'Loading',
      loadingText: 'Loading BMW Pricing',
    };
    this.loadingAreaService.addLoadingArea(this.loadingAreaConfig);
    this.pricePerBodyRequest = {
      bodyno: '',
      vin:bodyNo || '',
    };
    this.pricePerBodyService
      .getPricePerBody(this.pricePerBodyRequest)
      .subscribe(
        (response) => {
          console.log('Price per body response:', response);
          this.modelPricingModal.pricePerBodyResponse = response;
          this.modelPricingModal.processPricePerBodyResponse(response);
          this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
          this.modelPricingModal.modelPricingModalIsOpen = true;
        },
        (error) => {
          this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
          console.error('Error fetching price per body:', error);
          this.toastService.pushToast(error);
        }
      );
  }
  unitSearchReserveRequest: UnitSearchReserveRequest = {
    reserve: '',
    onoroff: '',
    vin: '',
    userid: '',
    body_no: '',
  };
  updateViewComment(comments: string, bodyNo: string, vin: string) {
    this.loadingAreaConfig = {
      id: 'commentLoading',
      loadingTitle: 'Loading',
      loadingText: 'Loading Comment History',
    };
    this.loadingAreaService.addLoadingArea(this.loadingAreaConfig);
    this.updateCommentModalComponent.updateCommentModalData.bodyNo = bodyNo;
    this.updateCommentModalComponent.updateCommentModalData.vin = vin;
    this.updateCommentModalComponent.updateCommentModalData.currentComment =
      comments;



    this.unitSearchReserveRequest.onoroff = 'H';
    this.unitSearchReserveRequest.vin = vin;
    this.unitSearchReserveRequest.userid = localStorage.getItem('euserid') || '';
    this.unitSearchReserveRequest.body_no = bodyNo;
    this.crossBorderService
      .unitSearchReserve(this.unitSearchReserveRequest)
      .subscribe(
        (response) => {
          console.log('Comment history:', response);
          if(response.rsrvehist){
            this.updateCommentModalComponent.commentHistory = response.rsrvehist;
          }
          this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id = 'commentLoading');
          this.updateCommentModalComponent.modelPricingModalIsOpen = true;

        },
        (error) => {
          console.error('Error updating comment:', error);

        }
      );


  }
}
